import * as React from "react"

import { Progress } from "@/shadcn/components/ui/progress"

import { progressFallback, progressPhases } from "./copy"
import type { MedicProgress as MedicProgressData } from "./types"

export default function MedicProgress({ progress }: { progress?: MedicProgressData }) {
  if (!progress) return null

  const pct = Math.min(100, Math.round((progress.overallPct ?? 0) * 100))
  /*
   * Server-side phase messages (`progress.msg`) are raw lowercase strings like
   * "Checking accessibility" built from the internal check name, so the local
   * phase map wins whenever the phase is one we recognise. `msg` is only a
   * fallback for a phase this build hasn't been taught yet.
   */
  const label =
    progressPhases[progress.phase as keyof typeof progressPhases] ??
    progress.msg ??
    progressFallback

  return (
    <div className="tw:flex tw:flex-col tw:gap-2">
      <Progress value={pct} className="tw:h-1.5" />
      <div className="tw:flex tw:items-center tw:gap-1.5 tw:text-sm tw:text-muted-foreground">
        <span>{label}</span>
        <span className="tw:tabular-nums">({pct}%)</span>
      </div>
    </div>
  )
}
